import React from 'react';

import NavigationMenuSection from "../../menu-items/section/section";
import NavigationMenuItemProjectWithChildren from "../../menu-items/project/menu-item-project-with-children";
import NavigationMenu_ProjectsLocalSettings from "../../local-settings";
import {SpaceProto} from "../../../../core/model2/space/space-proto";
import ProjectSession from "../../../../core/model2/project/project-session";

type Props = {
    space: SpaceProto
}

export default function NavigationMenu_StarredProjects(props:Props) {

    const starredProjects    = props.space.starredProjects

    if (_.isEmpty(starredProjects)) return null

    const colorize = props.space.projectsColorize

    const localSettings = new NavigationMenu_ProjectsLocalSettings()

    return (
        <NavigationMenuSection name="Starred" starred={true} systemName="projectsStarred" collapsible={true} counter={starredProjects.length}>
            {starredProjects.map((project:ProjectSession)=>{

                return <NavigationMenuItemProjectWithChildren key={project.id} projectId={project.id} colorized={colorize} localSettings={localSettings} />

            })}
        </NavigationMenuSection>
    )
}
